import {
  GeolocationPlugin,
  GeolocationOptions,
  GeolocationPosition,
  GeolocationWatchCallback,
} from '@absis/core-plugins';

export class GeolocationPluginWeb implements GeolocationPlugin {
  getCurrentPosition(
    options?: GeolocationOptions
  ): Promise<GeolocationPosition> {
    return new Promise((resolve, reject) => {
      return navigator.permissions.query({ name: 'geolocation' }).then(() => {
        window.navigator.geolocation.getCurrentPosition(
          position => {
            const glp: GeolocationPosition = {
              coords: {
                accuracy: position.coords.accuracy,
                altitude: position.coords.altitude || undefined,
                altitudeAccuracy: position.coords.altitudeAccuracy || undefined,
                heading: position.coords.heading || undefined,
                latitude: position.coords.latitude,
                longitude: position.coords.longitude,
                speed: position.coords.speed || undefined,
              },
              timestamp: position.timestamp,
            };
            resolve(glp);
          },
          err => {
            reject(err);
          },
          {
            enableHighAccuracy: true,
            timeout: 10000,
            maximumAge: 0,
            ...options,
          }
        );
      });
    });
  }

  watchPosition(
    options: GeolocationOptions,
    callback: GeolocationWatchCallback
  ): string {
    const id = window.navigator.geolocation.watchPosition(
      position => {
        const glp: GeolocationPosition = {
          coords: {
            accuracy: position.coords.accuracy,
            altitude: position.coords.altitude || undefined,
            altitudeAccuracy: position.coords.altitudeAccuracy || undefined,
            heading: position.coords.heading || undefined,
            latitude: position.coords.latitude,
            longitude: position.coords.longitude,
            speed: position.coords.speed || undefined,
          },
          timestamp: position.timestamp,
        };
        callback(glp);
      },
      err => {
        callback(undefined, err);
      },
      {
        enableHighAccuracy: true,
        timeout: 10000,
        maximumAge: 0,
        ...options,
      }
    );

    return `${id}`;
  }

  clearWatch(options: { id: string }) {
    window.navigator.geolocation.clearWatch(parseInt(options.id, 10));
    return Promise.resolve();
  }
}

const CBGeolocation = new GeolocationPluginWeb();

export { CBGeolocation };
